import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ar from "./locales/ar.json";
import en from "./locales/en.json";
import ku from "./locales/ku.json";

// Check if running as a standalone PWA or on the menu page
const isStandalone = window.matchMedia("(display-mode: standalone)").matches || 
                     (window.navigator && "standalone" in window.navigator && (window.navigator as any).standalone);
const isMenuPath = window.location.pathname.startsWith("/menu");

// If in menu or standalone mode, default to Arabic (fallbackLng) by ignoring navigator language.
// If on the website, respect the device/browser language (navigator).
const detectionOrder = (isStandalone || isMenuPath) 
  ? ["localStorage"] 
  : ["localStorage", "navigator"];

const configLng = (isStandalone || isMenuPath) ? "ar" : undefined;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: configLng,
    resources: {
      ar: { translation: ar },
      en: { translation: en },
      ku: { translation: ku },
    },
    fallbackLng: "ar",
    supportedLngs: ["ar", "en", "ku"],
    interpolation: { escapeValue: false },
    detection: {
      order: detectionOrder,
      caches: ["localStorage"],
    },
  });

export default i18n;
